<template>
    <svg 
        :width="width"
        :height="height" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0521 3.04211C8.69509 3.33853 6.40494 4.60133 4.89845 6.43528C4.34343 7.11094 3.75797 8.07932 3.4843 8.77436C3.34819 9.12007 3.34712 9.11954 4.62607 9.32862C5.22178 9.42602 5.73656 9.4954 5.77009 9.48286C5.80363 9.47028 5.91168 9.30317 6.01018 9.1115C7.23164 6.73548 10.0317 5.13509 12.4923 5.40667C14.418 5.61924 16.0648 6.58602 17.1151 8.12045C17.3334 8.43946 17.623 8.97338 17.5933 9.00232C17.5755 9.01969 15.97 9.30948 15.8915 9.30948C15.8743 9.30948 15.8662 9.3367 15.8735 9.36994C15.891 9.44949 19.6562 13.249 19.7175 13.249C19.7435 13.249 20.2514 12.1862 20.8463 10.8873C22.0383 8.28434 22.0238 8.3173 21.9902 8.28442C21.9771 8.27171 21.5449 8.33543 21.0297 8.42608C20.5144 8.51668 20.0787 8.57618 20.0615 8.55821C20.0442 8.54028 19.962 8.3628 19.8788 8.16382C18.8203 5.63223 16.3755 3.68903 13.5826 3.15941C12.7648 3.00432 11.733 2.95649 11.0521 3.04211ZM4.21029 10.8049C4.19823 10.8336 3.69596 11.9322 3.09416 13.2462C2.4924 14.5602 2 15.6591 2 15.6882C2 15.7174 2.00988 15.7413 2.02189 15.7413C2.03395 15.7413 2.46285 15.6683 2.97504 15.5791C3.48723 15.4898 3.91959 15.4311 3.93588 15.4484C3.95213 15.4658 4.05101 15.679 4.1556 15.9222C4.36911 16.4188 4.71165 17.0076 5.0711 17.4959C6.74986 19.7766 9.51109 21.1002 12.3688 20.9941C13.108 20.9666 13.5956 20.8919 14.2724 20.7023C16.4856 20.0822 18.4412 18.6545 19.7106 16.7322C19.9865 16.3143 20.3387 15.6557 20.4969 15.2616C20.6641 14.8453 20.6992 14.8646 19.3917 14.6541C18.7973 14.5584 18.2799 14.4917 18.242 14.5059C18.2041 14.5202 18.0908 14.6917 17.9904 14.8872C16.7646 17.2716 13.9699 18.871 11.5047 18.5989C9.56635 18.385 7.93594 17.4229 6.86536 15.8613C6.64478 15.5395 6.37362 15.0326 6.40543 15.0016C6.42106 14.9863 8.04033 14.6961 8.10995 14.6961C8.12139 14.6961 8.13077 14.6735 8.13073 14.6459C8.13068 14.5834 4.36713 10.7813 4.28896 10.7647C4.25777 10.7581 4.22238 10.7762 4.21029 10.8049Z" :fill="iconColor"/>
    </svg>
  </template>
  
  <script>
  export default {
  name: "IconRepeatRound",
  props: {
      iconName: {
        type: String,
        default: "iconChat",
      },
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
      iconColor: {
        type: String,
        default: "currentColor",
      },
    },
  };
  </script>
  